import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

import { SubscriptionContainer, SubscriptionContent, SubscriptionHeader } from '../../components/Subscriptions';

const Subscription = props => {
  const { title } = props;

  return (
    <SubscriptionContainer>
      <SubscriptionHeader title={title} />
      <SubscriptionContent />
    </SubscriptionContainer>
  );
};

Subscription.displayName = 'Subscription';

Subscription.propTypes = {
  title: PropTypes.string.isRequired,
};

export default observer(Subscription);
